module.exports = __webpack_public_path__ + "static/media/Banner_Tablet2x.bd979a1b.jpg";